<template>
    <i class="text-dark fas fa-chart-pie" aria-hidden="true"></i>
</template>